import React, { FC } from 'react';
import { MtsLink } from '@mts-ds/components-react';

const TableColLink: FC = ({ children }) => {
  return <MtsLink>{children}</MtsLink>;
};

export default TableColLink;
